module.exports = __webpack_public_path__ + "img/icon_love.000ff39b.png";